import OverlayTips from "../OverlayTips";

function InvoiceReportPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

InvoiceReportPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle"), {
            messageKey: "tips.invoice_report.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".controlsContainer"), {
            messageKey: "tips.invoice_report.controls",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -40,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -10,
                offsetY: 60
            }
        });

        this.add($("#applyReportConfiguration"), {
            messageKey: "tips.invoice_report.preview",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -10,
            offsetY: -10
        });
    }
});

export default InvoiceReportPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/InvoiceReportPageOverlayTipsManager.js